let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("03UH2")).then(() => parcelRequire('5L7lK'));